import React from "react"
import OccupancyInfo from "./OccupancyInfo"
import type { TypeI18n, TypeStatus } from "../../../types"
import config from "../../../config"
import RestaurantInfoConnected from "./RestaurantInfo"

const pictureFloor = {
  basicFloor: require("./basicfloor.svg"),
  topFloor: require("./topfloor.svg"),
  bottomFloor: require("./bottomfloor.svg")
}

type TypeProps = {
  i18n: TypeI18n,
  floor: { label: string, value: string },
  status: TypeStatus[]
}

class OccupancyRow extends React.PureComponent<TypeProps, void> {
  render() {
    const { i18n, floor, status } = this.props

    return (
      <div style={styles.rowContainer}>
        <div style={styles.occupancyDataContainer}>
          {floor.value !== "N00" && (
            <OccupancyInfo
              data={status.filter(
                item =>
                  item.poiType === "desk" && item.spaceId.includes("CBREN0")
              )}
              type={"desk"}
              i18n={i18n}
            />
          )}
          {floor.value === "N00" && <RestaurantInfoConnected />}
        </div>

        <div style={styles.buildingContainer}>
          <div
            style={
              floor.value === "N00"
                ? styles.imageContainerBottom
                : styles.imageContainer
            }
          >
            <img
              alt={"floorImg"}
              width="100%"
              height="100%"
              src={
                floor.value === "N00"
                  ? pictureFloor["bottomFloor"]
                  : floor.value === "N08"
                  ? pictureFloor["topFloor"]
                  : pictureFloor["basicFloor"]
              }
            />
          </div>
          <div style={styles.levelContainer}>
            <p style={styles.levelText}>{floor.label}</p>
          </div>
        </div>

        <div style={styles.occupancyDataContainer}>
          <OccupancyInfo
            data={status.filter(
              item => item.poiType === "room" && item.spaceId.includes("CBREN0")
            )}
            type={"room"}
            i18n={i18n}
          />
        </div>
      </div>
    )
  }
}

export default OccupancyRow

const styles = {
  rowContainer: {
    flexDirection: "row",
    width: "100%",
    display: "flex",
    flex: 1
  },
  occupancyDataContainer: {
    display: "flex",
    width: "33.3%",
    paddingTop: 15,
    flex: 1
  },
  buildingContainer: {
    display: "flex",
    justifyContent: "center",
    flex: 1,
    alignItems: "center",
    position: "relative",
    paddingLeft: 15,
    paddingRight: 15,
    flexDirection: "row"
  },
  levelContainer: {
    padding: 3,
    left: "50%",
    top: "50%",
    transform: "translate(-50%,-50%)",
    backgroundColor: config.theme.colors.main,
    position: "absolute"
  },
  levelText: {
    color: "white",
    margin: 0,
    fontSize: "3vmin",
    paddingLeft: 10,
    paddingRight: 10
  },
  imageContainer: {
    width: "100%",
    height: "100%",
    borderWidth: "3px 3px 0px 3px",
    borderStyle: "solid",
    paddingLeft: 5,
    paddingRight: 5
  },
  imageContainerBottom: {
    width: "100%",
    height: "100%",
    borderWidth: "3px",
    borderStyle: "solid",
    paddingLeft: 5,
    paddingRight: 5
  }
}



// WEBPACK FOOTER //
// ./src/ui/screens/occupancy/OccupancyRow.js